import React, { useState } from "react";
import conditionctevt from "../conditions/conditionctevt";
function CTEVT() {
  const [selected, setSelected] = useState([]);
  const [popupTrue, setPopupTrue] = useState(false);
  const [resultMessage, setResultMessage] = useState();

  const handleSelected = (event) => {
    const { name, checked } = event.target;
    setSelected(
      (prevSelected) =>
        checked
          ? [...prevSelected, name] // Add item if checked
          : prevSelected.filter((item) => item !== name) // Remove item if unchecked
    );
  };

  function compareArrays(array1, array2) {
    const missingElements = array1.filter(
      (element) => !array2.includes(element)
    );
    return missingElements.length === 0 ? true : missingElements;
  }
  const handleSubmit = (e) => {
    e.preventDefault();
    const result = compareArrays(conditionctevt, selected);
    if (result === true) {
      setResultMessage(true);
    } else {
      setResultMessage(result);
    } 
    setPopupTrue(true);
  };

  return (
    <>
      {popupTrue && (
        <Popup setPopupTrue={setPopupTrue} resultMessage={resultMessage} />
      )}
      <form
        onSubmit={handleSubmit}
        className="flex items-center justify-center flex-col"
      >
        <p className="text-xl text-green-700 text-center font-bold">
          Select the boxes to check if you are eligible or not?
        </p>
        {conditionctevt.map((item, index) => (
          <div
            key={index}
            className="flex gap-2 p-2 w-full items-center border-b justify-start h-auto"
          >
            <input
              type="checkbox"
              onChange={handleSelected}
              name={item}
              className="h-5 w-5 self-start"
            />
            <p className="text-md">{item}</p>
          </div>
        ))}
        <input
          type="submit"
          className="h-10 w-20 mt-3 rounded-xl text-base bg-green-700 cursor-pointer text-white transition-all hover:bg-green-800 font-bold"
          value="Submit"
        />
      </form>
    </>
  );
}

export default CTEVT;

export function Popup({ setPopupTrue, resultMessage }) {
  const handleDisplay = () => {
    setPopupTrue(false);
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60">
      <div className="h-auto w-[90%] p-5 md:w-auto md:p-5 pt-0 bg-white rounded-xl flex items-center justify-evenly flex-col overflow-y-scroll">
      <br />
        {resultMessage === true ? (
          <p className="text-center text-2xl text-green-700 font-bold">
            ✅Congratulations!! <br />
            You can enroll in the program
          </p>
        ) : (
          <>
            <p className="text-center font-semibold text-2xl">
              ❌Sorry! You cannot enroll in the program  <br />{" "}
              <span className="text-lg">These might be the reasons</span>{" "}
            </p>
            <ul className="pl-5">
              {Array.isArray(resultMessage) && resultMessage.length > 0 ? (
                resultMessage.map((item, index) => (
                  <li key={index} className="text-md list-disc text-red-600">
                     {item}
                  </li>
                ))
              ) : (
                <li className="text-md text-red-600">No missing items.</li>
              )}
            </ul>
          </>
        )}
        <button
          className="h-8 w-28 mt-3 rounded-xl text-md bg-green-700 cursor-pointer flex items-center justify-center text-white transition-all hover:bg-green-800 font-bold"
          onClick={handleDisplay}
        >
          Close
        </button>
      </div>
    </div>
  );
}
